import player from './assets/player.png'
import family from './assets/family.png'
import whiteArrow from './assets/white-arrow.svg';

const Rooms = () => {
    return ( 
        <div className="rooms-wrapper">
            <h2 className='room-title'>Para quem você está procurando a sala de apoio?</h2>
            <div className="rooms-choice">
                <div className="room-card">
                    <div className='image-wrapper'>
                        <img src={family} alt="" />
                    </div>
                    <div className="room-texts">
                        <h2>Você não está sozinho.</h2>
                        <p>Saiba como superar, ou ajudar alguém que você gosta a superar o vício.</p>
                        <p>Quarta-feira - 19h.</p>
                    </div>
                    <a href="https://meet.google.com/ssg-nmzm-ytc" target='_blank' rel='noreferrer'> <div className="arrow"><img src={whiteArrow} alt="" /></div></a>
                </div>
            </div>
        </div>
     );
}
 
export default Rooms;